import { APIEndpoint } from ".";

const token = localStorage.getItem("token");

export const registerSnapTradeUser = async (email?: string) => {
  const response = await fetch(`${APIEndpoint}/snaptrade/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token || "",
    },
    body: JSON.stringify({ email }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "Failed to register SnapTrade user");
  }
  return data;
};

export const getSnapTradeInit = async () => {
  const response = await fetch(`${APIEndpoint}/snaptrade/init`, {
    method: "GET",
    headers: {
      Authorization: token || "",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "Failed to init SnapTrade");
  }
  return data as { snapTradeUserId: string | null };
};

export const getConnectionPortalUrl = async (broker?: string) => {
  const response = await fetch(`${APIEndpoint}/snaptrade/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token || "",
    },
    body: JSON.stringify({ broker }),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "Failed to create connection portal URL");
  }
  return data as { success: boolean; redirectURI?: string; sessionId?: string };
};

export const getConnections = async () => {
  const response = await fetch(`${APIEndpoint}/snaptrade/connections`, {
    method: "GET",
    headers: {
      Authorization: token || "",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "Failed to load connections");
  }
  return data as { success: boolean; data: any[] };
};

export const getConnectionDetail = async (id: string) => {
  const response = await fetch(`${APIEndpoint}/snaptrade/connections/${id}`, {
    method: "GET",
    headers: {
      Authorization: token || "",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "Failed to load connection detail");
  }
  return data as { success: boolean; data: any };
};

export const deleteConnection = async (id: string) => {
  const response = await fetch(`${APIEndpoint}/snaptrade/connections/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: token || "",
    },
  });
  if (!response.ok && response.status !== 204) {
    const data = await response.json().catch(() => ({}));
    throw new Error((data as any)?.message || "Failed to delete connection");
  }
  return true;
};

export const getConnectionAccounts = async (id: string) => {
  const response = await fetch(`${APIEndpoint}/snaptrade/connections/${id}/accounts`, {
    method: "GET",
    headers: {
      Authorization: token || "",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "Failed to load connection accounts");
  }
  return data as { success: boolean; data: any[] };
};

export const refreshConnection = async (id: string) => {
  const response = await fetch(`${APIEndpoint}/snaptrade/connections/${id}/refresh`, {
    method: "POST",
    headers: {
      Authorization: token || "",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "Failed to refresh connection");
  }
  return data as { success: boolean };
};

export const getAccountBalances = async (accountId: string) => {
  const response = await fetch(`${APIEndpoint}/snaptrade/accounts/${accountId}/balances`, {
    method: "GET",
    headers: {
      Authorization: token || "",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "Failed to load balances");
  }
  return data as { success: boolean; data: any[] };
};

export const getAccountPositions = async (accountId: string) => {
  const response = await fetch(`${APIEndpoint}/snaptrade/accounts/${accountId}/positions`, {
    method: "GET",
    headers: {
      Authorization: token || "",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "Failed to load positions");
  }
  return data as { success: boolean; data: any[] };
};

export const getAccountActivities = async (
  accountId: string,
  params?: { startDate?: string; endDate?: string; offset?: number; limit?: number; type?: string }
) => {
  const qs = new URLSearchParams();
  if (params?.startDate) qs.set("startDate", params.startDate);
  if (params?.endDate) qs.set("endDate", params.endDate);
  if (typeof params?.offset === "number") qs.set("offset", String(params.offset));
  if (typeof params?.limit === "number") qs.set("limit", String(params.limit));
  if (params?.type) qs.set("type", params.type);
  const response = await fetch(`${APIEndpoint}/snaptrade/accounts/${accountId}/activities?${qs.toString()}`, {
    method: "GET",
    headers: {
      Authorization: token || "",
    },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.message || "Failed to load activities");
  }
  return data as { success: boolean; data: any[] };
};

export default {
  registerSnapTradeUser,
  getSnapTradeInit,
  getConnectionPortalUrl,
  getConnections,
  getConnectionDetail,
  deleteConnection,
  getConnectionAccounts,
  refreshConnection,
  getAccountBalances,
  getAccountPositions,
  getAccountActivities,
};


